export default "__VITE_ASSET__65113504__"